import React from "react";
import { Link } from "react-router-dom";
import executivesData from "../../data/seniorexecutiveteamdata";

const TeamMemberSection = () => {
  return (
    <div>
      <div className="flex justify-center">
        <div className="max-w-6xl">
          <div className="my-10 mx-5">
            <div className="flex justify-center items-center">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7 md:gap-4">
                {executivesData.map((executive) => (
                  <Link
                    to={`/about/executive-team/${executive.id}`}
                    key={executive.id}
                  >
                    <div className="group space-y-3 max-w-96">
                      {/* Image */}
                      <div className="w-full h-96 sm:h-[500px] lg:h-80 overflow-hidden rounded-md border-2 border-sddarkgray/60">
                        <img
                          src={executive.image}
                          alt={executive.name}
                          className="w-full h-full object-top object-cover transform transition-transform duration-500 ease-in-out group-hover:scale-110"
                        />
                      </div>
                      <div className="h-[230px]  md:h-[270px] flex flex-col ">
                        <div >
                          <div className="border-b-2  group-hover:text-sdorange  inline-block">
                            <p className="font-bold">{executive.name}</p>
                          </div>
                        </div>
                        <div className="flex mb-4 mt-3 space-x-2">
                          <div className="flex items-center">
                            <img
                              src="/image-fix/executive-team-images/executive-team-icons/admin-users-svgrepo-com.svg"
                              className="h-6 w-6"
                              alt=""
                            />
                          </div>

                          <div className="flex items-center  group-hover:border-sdorange">
                            <p>{executive.position}</p>
                          </div>
                        </div>
                        <div>
                          <p className="text-slate-500 group-hover:text-sddarkgray">
                            {executive.aboutPosition}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMemberSection;
